import {
  WorkLogsApiListWorkLogsRequest,
  WorkLogStatus
} from "@wingspanhq/wingspan-api-sdk";
import { Filter, WorkLogPayerTabFilterStatus } from "./types";

const PAYER_STATUS_MAP: Record<WorkLogPayerTabFilterStatus, WorkLogStatus> = {
  [WorkLogPayerTabFilterStatus.ToApprove]: WorkLogStatus.IN_REVIEW,
  [WorkLogPayerTabFilterStatus.InProgress]: WorkLogStatus.IN_PROGRESS,
  [WorkLogPayerTabFilterStatus.Approved]: WorkLogStatus.APPROVED,
  [WorkLogPayerTabFilterStatus.Rejected]: WorkLogStatus.REJECTED
};

export function createListRequest(
  accountId: string,
  filter?: Filter
): WorkLogsApiListWorkLogsRequest {
  const request: WorkLogsApiListWorkLogsRequest = {
    filter: {
      // Account scope mapped to `payerAccountId.eq` from the v3 session accountId.
      payerAccountId: { eq: accountId }
    }
  };

  if (filter?.payeeEngagementId) {
    request.filter!.payeeEngagementId = { eq: filter.payeeEngagementId };
  }

  if (filter?.payPeriodId) {
    request.filter!.payPeriodId = { eq: filter.payPeriodId };
  }

  if (filter?.status) {
    request.filter!.status = { anyOf: [PAYER_STATUS_MAP[filter.status]] };
  }

  return request;
}
